import React from "react";
import { SocialShare } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";
import { object, number, string, bool, array } from "prop-types";
import ClockIcon from "../../basic/icons/clock-icon";
import { getDateTimeFromUnixTimestamp } from "../../helper/utils";
import CarouselCard from "../../molecules/story-card-5";
import Headline from "../../atoms/headline";
import HorizontalStoryCard from "../../molecules/horizontal-story-card";
import StoryHeader from "../../molecules/story-header";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import AuthorDetails from "../../molecules/author-details";
import StoryTags from "../story-tag";
import StoryCard from "../story-card";
import { CardShareTemplate } from "./card-share";
import MetypeCommentWrapper from "../../metype-comments";
import SideBarCollectionWithAd from "../../molecules/sidebar-collection-ad";
import "./liveblog.m.css";
import fetchRelatedStories from "../../utils/fetch-related-stories";

class LiveBlogTemplate extends React.Component {
  state = {
    renderMetype: false,
    relatedStories: []
  };

  componentDidMount() {
    const { story, cardId } = this.props;
    const sectionId = get(story, ["sections", "0", "id"]);

    fetchRelatedStories(story.id, sectionId).then(relatedStories => this.setState({ relatedStories }));

    if (cardId) {
      setTimeout(function() {
        document.getElementById(cardId) &&
          document.getElementById(cardId).scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
      }, 1000);
    }

    this.setState({
      renderMetype: true,
      cardsCount: story.cards.length,
      story: story
    });

    this.storyUpdate = setInterval(this.updateStory.bind(this), 30000);
  }

  componentWillUnmount() {
    clearInterval(this.storyUpdate);
  }

  async updateStory() {
    const response = await window.fetch(`/api/v1/stories/${this.props.story.id}`);
    const jsonResponse = await response.json();

    this.setState({
      cardsCount: jsonResponse.story.cards.length,
      story: jsonResponse.story
    });
  }

  liveblogData(story) {
    return (
      story &&
      story.cards.map((card, index) => (
        <React.Fragment key={card.id}>
          <div className="story-cards" id={card.id} key={index}>
            <div styleName="show-time">
              <div styleName="published-time">
                <span styleName="clock-icon">
                  <ClockIcon color={this.props.color} />
                </span>
                <span>{getDateTimeFromUnixTimestamp(card["card-added-at"])}</span>
              </div>
              <SocialShare
                template={CardShareTemplate}
                title={card.metadata["social-share"].title || story.headline}
                url={encodeURIComponent(story && story.slug + "?cardId=" + card.id)}
                color="#333"
                styleName="share-icon"
              />
            </div>

            <StoryCard key={card.id} card={card} story={story} />
          </div>
        </React.Fragment>
      ))
    );
  }

  relatedStoriesMobile() {
    return (
      <div className="container" styleName="show-mobile">
        <Headline text="Related Stories" headerType={8} headerLevel={2} />
        {this.state.relatedStories.map((item, index) => (
          <HorizontalStoryCard story={item} key={index} SectionName="Related Stories" />
        ))}
      </div>
    );
  }

  relatedStoriesDesktop() {
    return (
      <div className="container" styleName="show-desktop">
        <Headline text="Related Stories" headerType={8} headerLevel={2} />
        <div styleName="related-story">
          {this.state.relatedStories.map((item, index) => (
            <CarouselCard
              story={item}
              headerLevel={4}
              headerType={3}
              imageType="image16x9"
              sectionTitle
              showPublishedTime
              key={index}
            />
          ))}
        </div>
      </div>
    );
  }

  render() {
    const { story, collections, breakingNewsLoaded, breakingNews } = this.props;
    const sectionName = story.sections[0].name || story.sections[0]["display-name"];
    const isBreakingNews = !!(breakingNewsLoaded && breakingNews.length !== 0);

    const authorDetails = {
      name: get(story, ["authors", 0, "name"], story["author-name"]),
      id: story["author-id"],
      "twitter-handle": get(story, ["authors", 0, "twitter-handle"]),
      "avatar-url": get(story, ["authors", 0, "avatar-url"]),
      slug: get(story, ["authors", 0, "slug"]),
      "avatar-s3-key": get(story, ["authors", 0, "avatar-s3-key"])
    };

    return (
      <div className="story-grid" styleName={isBreakingNews ? "" : "heading-top-margin"}>
        <div styleName="liveblog-story">
          <div className="liveblog">
            <StoryHeader sectionName={sectionName} story={story} />
            <div styleName="story-body">
              <SocialShare
                template={StickySocialShareTemplate}
                title={story.headline}
                url={story.slug}
                color="#000"
                sticky
              />
              <div styleName="story-content">
                <div styleName="author-wrapper">
                  <AuthorDetails author={authorDetails} updatedOn={story["last-published-at"]} />
                </div>
                {!this.state.cardsCount ? this.liveblogData(story) : this.liveblogData(this.state.story)}
                <StoryTags tags={story.tags} />
              </div>
            </div>
          </div>
          <SideBarCollectionWithAd collections={collections} story={story} />
        </div>
        {this.relatedStoriesDesktop()}
        {this.relatedStoriesMobile()}
        <div styleName="metype-widget">{this.state.renderMetype && <MetypeCommentWrapper story={story} />}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { breakingNews, breakingNewsLoaded } = state;

  return {
    breakingNews,
    breakingNewsLoaded
  };
}

LiveBlogTemplate.propTypes = {
  story: object,
  metypeConfig: object,
  collections: object,
  color: string,
  cardId: string,
  cardsCount: number,
  breakingNews: array,
  breakingNewsLoaded: bool
};

const LiveBlogStory = connect(mapStateToProps)(LiveBlogTemplate);

export default LiveBlogStory;
